export default __webpack_public_path__ + "static/media/left-arrow-w-bg.ed523a53.svg";